// import React from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import CustomerCustomDashboard from "../../CustomerManagement/CustomerCustomDashboard";

// const SaveCustomeViewModal = (props) => {
//     const currentPath = window.location.pathname;
//     return (
//         <Modal show={props.open} onHide={props.handleCloseModal} className='save-custom-view-modal'>
//             <Modal.Header closeButton>
//                 <Modal.Title>Save Custom View</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className='customer-view-form-fields'>
//                     <Col>
//                         <Row>
//                             <Col>
//                                 <p>
//                                     Save your own custom view with all filters applied, to eliminate the need to filter every time you open the dashboard.
//                                 </p>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col md={12}>
//                                 <div>
//                                     <label>Name</label>
//                                     <Form.Control type="text" />
//                                 </div>
//                             </Col>
//                         </Row>
//                         {/* Render this section only for /dashboard */}
//                         {currentPath === "/dashboard" && (
//                             <Row>
//                                 <CustomerCustomDashboard />
//                             </Row>
//                         )}
//                         <Row className="custom-view-form-checkbox-container">
//                             <Col md={6}>
//                                 <div className="checkbox-container">
//                                     <Form.Check
//                                         type="checkbox"
//                                         id="default-checkbox"
//                                         defaultChecked
//                                         label="Make it my default"
//                                     />
//                                 </div>
//                             </Col>
//                             <Col md={6}>
//                                 <div className="checkbox-container">
//                                     <Form.Check
//                                         type="checkbox"
//                                         id="visible-checkbox"
//                                         label="Make visible to others"
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
//                 <SBSaveUpdateBtn btnName="Submit" onClickEffect={props.handleNextStep} />
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default SaveCustomeViewModal;





import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import CustomerCustomDashboard from "../../CustomerManagement/CustomerCustomDashboard";
import { useDispatch } from "react-redux";
import { postCustomDashboardData } from "../../../redux/action";
import * as HeaderAuthentication from "../../../components/HeaderAuthentication";
import { ADDED_BY_ID } from "../../../Constants";
import UserCustomDashboard from "../../UserManagement/UserCustomDashboard";
import ComplaintsCustomDashboard from "../../ComplaintEscalation/ComplaintsCustomDashboard";
import SlaCustomDashboard from "../../SLA/SlaCustomDashboard";
import LeavesCustomDashboard from "../../Leaves/LeavesCustomDashboard";

const SaveCustomeViewModal = (props) => {
    const currentPath = window.location.pathname;
    const dispatch = useDispatch();
    const customViews = props.customViews;
    const customDashboardId = props.customDashboardId;
    const loadDashboardsByPath = props.loadDashboardsByPath;

    const [formData, setFormData] = useState({
        dashboardName: '',
        makeDefault: true,
        makeVisibleToOthers: false,
        selectedGraphs: []
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));

        // Clear the error for the current field
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleGraphsChange = (selected) => {
        setFormData((prev) => ({
            ...prev,
            selectedGraphs: selected
        }));
    };

    const getModuleID = () => {
        if (currentPath === "/dashboard") return 2;
        if (currentPath === "/licenceDashboard") return 3;
        if (currentPath === "/complaintDashboard") return 5;
        if (currentPath === "/slaDashboard") return 6;
        if (currentPath === "/attendanceDashboard") return 4;
        return null; // fallback or default
    };

    const handleSubmit = () => {
        if (!formData.dashboardName.trim()) {
            setErrors({ dashboardName: "Name is required" });
            return;
        }

        setErrors({});

        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails')) || [{}];
        const { SignInType, SuperAdminID, CompanyID, UserID } = signInDetails[0];
        const SignInID = SignInType === 'SuperAdmin' ? SuperAdminID : SignInType === 'ClientAdmin' ? CompanyID : UserID;

        const payload = {
            CustomDashboardID: customDashboardId,
            SignInType,
            SignInID,
            CompanyID,
            ModuleID: getModuleID(),
            DashboardName: formData.dashboardName.trim(),
            MakeDefault: formData.makeDefault,
            MakeItVisibleToOthers: formData.makeVisibleToOthers,
            GraphLibraryIDs: formData.selectedGraphs.map(g => g.value),
            ActivityLog_UpdatedByIDFK: ADDED_BY_ID,
            CustomViewLink: currentPath
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(payload),
        };

        dispatch(postCustomDashboardData(requestOption, props.handleCloseModal, customDashboardId, loadDashboardsByPath));
        // console.log(payload, 'payload')
    };

    useEffect(() => {
        // console.log(customViews, 'customViews')
        if (customDashboardId && customViews?.length > 0) {
            const view = customViews[0]; // First dashboard from API
            setFormData({
                dashboardName: view.DashboardName || '',
                makeDefault: view.IsDefault || false,
                makeVisibleToOthers: view.IsVisibleToOthers || false,
                selectedGraphs: view.Graphs.map((graph) => ({
                    label: graph.GraphLibraryName,
                    value: graph.GraphLibraryID
                })) || []
            });
        }
    }, [customDashboardId, customViews]);

    return (
        <Modal show={props.open} onHide={props.handleCloseModal} className='save-custom-view-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Custom View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-view-form-fields'>
                    <Col>
                        <Row>
                            <Col>
                                <p>
                                    Save your own custom view.
                                </p>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="dashboardName"
                                        value={formData.dashboardName}
                                        onChange={handleChange}
                                        placeholder="Enter dashboard name"
                                    />
                                </Form.Group>
                                {errors.dashboardName && <div className="text-danger">{errors.dashboardName}</div>}
                            </Col>
                        </Row>

                        {currentPath === "/dashboard" && (
                            <Row>
                                <CustomerCustomDashboard
                                    selectedGraphs={formData.selectedGraphs}
                                    setSelectedGraphs={handleGraphsChange}
                                />
                            </Row>
                        )}
                        {currentPath === "/licenceDashboard" && (
                            <Row>
                                <UserCustomDashboard
                                    selectedGraphs={formData.selectedGraphs}
                                    setSelectedGraphs={handleGraphsChange}
                                />
                            </Row>
                        )}
                        {currentPath === "/complaintDashboard" && (
                            <Row>
                                <ComplaintsCustomDashboard
                                    selectedGraphs={formData.selectedGraphs}
                                    setSelectedGraphs={handleGraphsChange}
                                />
                            </Row>
                        )}
                        {currentPath === "/slaDashboard" && (
                            <Row>
                                <SlaCustomDashboard
                                    selectedGraphs={formData.selectedGraphs}
                                    setSelectedGraphs={handleGraphsChange}
                                />
                            </Row>
                        )}
                        {currentPath === "/attendanceDashboard" && (
                            <Row>
                                <LeavesCustomDashboard
                                    selectedGraphs={formData.selectedGraphs}
                                    setSelectedGraphs={handleGraphsChange}
                                />
                            </Row>
                        )}
                        <Row className="custom-view-form-checkbox-container mt-3">
                            <Col md={6}>
                                <Form.Check
                                    type="checkbox"
                                    id="default-checkbox"
                                    name="makeDefault"
                                    checked={formData.makeDefault}
                                    onChange={handleChange}
                                    label="Make it my default"
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Check
                                    type="checkbox"
                                    id="visible-checkbox"
                                    name="makeVisibleToOthers"
                                    checked={formData.makeVisibleToOthers}
                                    onChange={handleChange}
                                    label="Make visible to others"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={handleSubmit} />
            </Modal.Footer>
        </Modal>
    );
};

export default SaveCustomeViewModal;

